import React from 'react'
import './home.css'
import logo from '../images/logo.png'
import { useNavigate } from "react-router-dom";
export default function Home() {
  let navigate = useNavigate();
  function ClickLogo() {
    let path = `/`;
    navigate(path);
  }
  return (
    <div>
      <img src={logo} alt="Logo" className='H-img1' onClick={ClickLogo}></img>
      <div>
        <img src='/images/7458330.png' alt="" className='H-img2'></img>
        <div className='H-encl'>
          <p className='H-p1'>India's first Influencer Marketing Platform</p>
          <p className='H-p2'>Interra provides an all-in-one platform for collaborations between brands and influencer</p>
        </div>
        <button onClick={() => {
          navigate("/signup")
        }} className='H-button H-btn1' type='submit'>
          Create Account
        </button>
        <button onClick={() => {
          navigate("/login")
        }} className='H-button H-btn2' type='submit'>
          Login
        </button>
      </div>
    </div>
  )
}